import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import DesktopShell from "../components/layout/DesktopShell";
import MobileShell from "../components/layout/MobileShell";
import AuthCard from "../components/Public/AuthCard";

export default function PassportPortalLogin() {
  const [isMobile, setIsMobile] = useState(false);
  const [isChecking, setIsChecking] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const checkScreenSize = () => {
      if (typeof window !== "undefined") {
        setIsMobile(window.innerWidth < 768);
      }
    };
    checkScreenSize();
    window.addEventListener("resize", checkScreenSize);
    return () => window.removeEventListener("resize", checkScreenSize);
  }, []);

  const handleMosipSignIn = async () => {
    setIsChecking(true);
    
    try {
      const authResponse = await axios.post(
        `${process.env.REACT_APP_API_URL}/auth/initiate`,
        {},
        { withCredentials: true }
      );
      
      if (authResponse.data.success && authResponse.data.authUrl) {
        window.location.href = authResponse.data.authUrl;
      }
    } catch (error) {
      console.error("Error initiating OAuth:", error);
      alert("Failed to initiate authentication. Please try again.");
      setIsChecking(false);
    }
  };

  const handleSupport = () => {
    console.log("Support clicked");
  };

  const Shell = isMobile ? MobileShell : DesktopShell;

  return (
    <>
      {/* Add Barlow font from Google Fonts */}
      <style>
        {`
          @import url('https://fonts.googleapis.com/css2?family=Barlow:wght@400;500;600;700&display=swap');
          
          body {
            font-family: 'Barlow', sans-serif;
            margin: 0;
            padding: 0;
          }
        `}
      </style>
      
      <div style={{ paddingTop: '8px' }}>
        <Shell>
          <AuthCard 
            isMobile={isMobile}
            onMosipSignIn={handleMosipSignIn} 
            onSupport={handleSupport}
            isLoading={isChecking}
          />
        </Shell>
      </div>
    </>
  );
}